import { render } from "./checkboxVeeV.vue?vue&type=template&id=fc4c038a"
import script from "./checkboxVeeV.vue?vue&type=script&lang=js"
export * from "./checkboxVeeV.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__